import React from 'react';

const EmptyChatIcon = (props: any) => {
  return (
    <svg height="119" width="216" fill="none" viewBox="0 0 216 119" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="108.5" cy="58.5" fill="#F1E7FF" r="58.5" />
      <g>
        <rect height="57" width="164" fill="#FCFAFF" rx="8" x="26" y="22" />
        <rect
          height="55.5"
          width="162.5"
          rx="7.25"
          stroke="url(#paint0_radial_8193_3320)"
          strokeOpacity="0.5"
          strokeWidth="1.5"
          x="26.75"
          y="22.75"
        />
        <rect
          height="55.5"
          width="162.5"
          rx="7.25"
          stroke="url(#paint1_radial_8193_3320)"
          strokeOpacity="0.4"
          strokeWidth="1.5"
          x="26.75"
          y="22.75"
        />
      </g>
      <g>
        <rect height="63" width="184" fill="#1A171E" rx="8" x="16" y="32" />
        <rect height="63" width="184" fill="url(#paint2_radial_8193_3320)" fillOpacity="0.22" rx="8" x="16" y="32" />
        <rect
          height="61.5"
          width="182.5"
          rx="7.25"
          stroke="url(#paint3_radial_8193_3320)"
          strokeWidth="1.5"
          x="16.75"
          y="32.75"
        />
        <rect
          height="61.5"
          width="182.5"
          rx="7.25"
          stroke="url(#paint4_radial_8193_3320)"
          strokeWidth="1.5"
          x="16.75"
          y="32.75"
        />
      </g>
      <g>
        <rect height="63" width="184" fill="#FBF9FF" rx="8" x="16" y="32" />
        <rect
          height="61.5"
          width="182.5"
          rx="7.25"
          stroke="url(#paint5_radial_8193_3320)"
          strokeWidth="1.5"
          x="16.75"
          y="32.75"
        />
        <rect
          height="61.5"
          width="182.5"
          rx="7.25"
          stroke="url(#paint6_radial_8193_3320)"
          strokeWidth="1.5"
          x="16.75"
          y="32.75"
        />
      </g>
      <path
        d="M58 75.3349L51.2066 80.7698C50.8913 81.0221 50.4593 81.0712 50.0954 80.8963C49.7315 80.7214 49.5 80.3533 49.5 79.9495V75.3349H46.6667C43.5371 75.3349 41 72.7977 41 69.6679V52.667C41 49.5372 43.5371 47 46.6667 47H69.3333C72.4629 47 75 49.5372 75 52.667V69.6679C75 72.7977 72.4629 75.3349 69.3333 75.3349H58Z"
        fill="#E4D5FA"
        fillRule="evenodd"
      />
      <path d="M50 56H66" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M50 61H66" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M50 66H66" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <rect height="7" width="62" fill="#E4D5FA" rx="3.5" x="99" y="46" />
      <rect height="7" width="58" fill="#E4D5FA" rx="3.5" x="99" y="74" />
      <rect height="7" width="85" fill="#E4D5FA" rx="3.5" x="99" y="60" />
      <defs>
        <radialGradient
          id="paint0_radial_8193_3320"
          cx="0"
          cy="0"
          gradientTransform="translate(3.44199 14.9523) rotate(17.4928) scale(138.212 156.888)"
          gradientUnits="userSpaceOnUse"
          r="1"
        >
          <stop stopColor="#E9D8FF" />
          <stop offset="0.910585" stopColor="#7C2FE2" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_8193_3320"
          cx="0"
          cy="0"
          gradientTransform="translate(203.578 86.1714) rotate(-159.602) scale(131.97 157.669)"
          gradientUnits="userSpaceOnUse"
          r="1"
        >
          <stop stopColor="#7142AE" />
          <stop offset="0.859375" stopColor="#E7D5FF" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_8193_3320"
          cx="0"
          cy="0"
          gradientTransform="translate(13.3938 33.8639) rotate(19.0107) scale(208.028 137.637)"
          gradientUnits="userSpaceOnUse"
          r="1"
        >
          <stop stopColor="#AB87DC" />
          <stop offset="0.448096" stopColor="#8749D9" />
          <stop offset="1" stopColor="#D1BAEF" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_8193_3320"
          cx="0"
          cy="0"
          gradientTransform="translate(-9.30898 24.2104) rotate(17.2481) scale(154.86 173.635)"
          gradientUnits="userSpaceOnUse"
          r="1"
        >
          <stop stopColor="#E9D8FF" />
          <stop offset="0.910585" stopColor="#7C2FE2" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_8193_3320"
          cx="0"
          cy="0"
          gradientTransform="translate(215.233 102.926) rotate(-159.881) scale(147.798 174.579)"
          gradientUnits="userSpaceOnUse"
          r="1"
        >
          <stop stopColor="#7142AE" />
          <stop offset="0.859375" stopColor="#E7D5FF" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_8193_3320"
          cx="0"
          cy="0"
          gradientTransform="translate(-9.30898 24.2104) rotate(17.2481) scale(154.86 173.635)"
          gradientUnits="userSpaceOnUse"
          r="1"
        >
          <stop stopColor="#E9D8FF" />
          <stop offset="0.910585" stopColor="#7C2FE2" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_8193_3320"
          cx="0"
          cy="0"
          gradientTransform="translate(215.233 102.926) rotate(-159.881) scale(147.798 174.579)"
          gradientUnits="userSpaceOnUse"
          r="1"
        >
          <stop stopColor="#7142AE" />
          <stop offset="0.859375" stopColor="#E7D5FF" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default EmptyChatIcon;
